import React from 'react';
import css from './TrackingPanel.module.css';
import { Icons } from '../../../components';
import moment from 'moment';
import { TRACKING_DATE_FORMAT } from '../../../util/enums';
import { SHIPPO_TRACKING_STATUSES } from '../../../config/enums';
import {
  capitalizeFirstLetter,
  getTrackingDetails,
  isArrayLength,
} from '../../../util/dataExtractors';
import classNames from 'classnames';

function TrackingPanel(props) {
  const { currentTransaction, liveTrackingDetails } = props;
  const metaTrackingDetails = getTrackingDetails(currentTransaction);
  const trackingHistory = liveTrackingDetails?.tracking_history;
  const liveStatues =
    isArrayLength(trackingHistory) && trackingHistory?.map(item => item?.substatus);

  const destination = liveTrackingDetails
    ? liveTrackingDetails?.address_to?.city + ', ' + liveTrackingDetails?.address_to?.country
    : '';

  const lastStatus = isArrayLength(trackingHistory)
    ? trackingHistory[trackingHistory?.length - 1]
    : null;

  return (
    <div className={css.trackOrderPage}>
      <div className={css.fixedWidthContainer}>
        <h1>Track order</h1>
        <div className={css.orderStatus}>
          <div className={css.orderIcon}>
            <Icons name="checkmarkLarge" />
          </div>
          <div className={css.orderInfo}>
            <h2>
              ETA :{' '}
              {liveTrackingDetails?.eta
                ? moment(liveTrackingDetails?.eta).format(TRACKING_DATE_FORMAT)
                : 'Will be available soon'}
            </h2>
            <p>{liveTrackingDetails?.tracking_number}</p>
          </div>
        </div>
        <div className={css.orderDetails}>
          <div className={css.orderBlock}>
            <div className={css.orderLabel}>Order ID</div>
            <div className={css.orderInfo}>{currentTransaction?.id?.uuid}</div>
          </div>
          <div className={css.orderBlock}>
            <div className={css.orderLabel}>Service type</div>
            <div className={css.orderInfo}>
              {liveTrackingDetails?.servicelevel?.name || metaTrackingDetails?.carrierName}
            </div>
          </div>
          <div className={css.orderBlock}>
            <div className={css.orderLabel}>Destination</div>
            <div className={css.orderInfo}>
              {liveTrackingDetails?.tracking_status?.location?.city || destination}
            </div>
          </div>
          <div className={css.orderBlock}>
            <div className={css.orderLabel}>Status</div>
            <div className={css.orderInfo}>
              <div className={css.delivered}>
                {liveTrackingDetails?.tracking_status?.status ? (
                  <>
                    <Icons name="checkmark" />
                    {capitalizeFirstLetter(
                      (liveTrackingDetails?.tracking_status?.status).toLowerCase()
                    )}
                  </>
                ) : (
                  lastStatus?.status || ''
                )}
              </div>
            </div>
          </div>
          <div className={css.orderBlock}>
            <div className={css.orderLabel}>Status Details</div>
            <div className={css.orderInfo}>
              <strong>
                {liveTrackingDetails?.tracking_status?.status_details || lastStatus?.status_details}
              </strong>
            </div>
          </div>
        </div>
        <div className={css.orderStates}>
          {[
            { status: SHIPPO_TRACKING_STATUSES.PRE_TRANSIT, label: 'Prepared' },
            { status: SHIPPO_TRACKING_STATUSES.PACKAGE_ACCEPTED, label: 'Booking' },
            { status: SHIPPO_TRACKING_STATUSES.PACKAGE_ARRIVED, label: 'Arrived' },
            { status: SHIPPO_TRACKING_STATUSES.PACKAGE_DEPARTED, label: 'In transit' },
            { status: SHIPPO_TRACKING_STATUSES.OUT_FOR_DELIVERY, label: 'Out for delivery' },
            { status: SHIPPO_TRACKING_STATUSES.DELIVERED, label: 'Delivered' },
          ].map(item => (
            <span
              key={item.status}
              className={classNames({
                [css.completed]: liveStatues && liveStatues.includes(item.status),
              })}
            >
              {item.label}
            </span>
          ))}
        </div>
        <div className={css.orderTrackingDetailTable}>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Location</th>
                <th>Activity</th>
              </tr>
            </thead>
            <tbody>
              {isArrayLength(trackingHistory)
                ? trackingHistory.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          {item?.status_date
                            ? moment(item?.status_date).format('MMM DD, YY')
                            : null}
                        </td>
                        <td>{item?.status}</td>
                        <td>{item?.location?.city}</td>
                        <td>{item?.status_details}</td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TrackingPanel;
